import * as React from "react";
import {cx} from "emotion";

import "./file-name-input.scss";

import {bindInput}   from "@Common/react/bind-input";
import {cs}          from "@Common/react/chain-services";
import {scopedState} from "@Common/react/scoped-state";
import {UseState}    from "@Common/react/use-state";

export const FileNameInput = ({state: valueState, fileType, className}) => cs(
    ["state", (_, next) => UseState({
        // getInitValue: () => ({value: valueState.value}),
        next,
    })],
    ({state}) => !state.value ? (
        <div
            className={cx("file-name-input-65f viewing", className)}
            onClick={() => state.onChange({value: valueState.value})}
        >
            <div className="text" xd-qa-type="label"
                    xd-qa-name="file name">
                {valueState.value}.{fileType}
            </div>

            <div className="controls">
                <i className="fa fa-pencil" xd-qa-type="icon" xd-qa-name="edit file name"/>
            </div>
        </div>
    ) : (
        <div className={cx("file-name-input-65f editing", className)}>
            <input {...{
                ...bindInput(scopedState(state, ["value"])),
                "xd-qa-type": "text_field",
                "xd-qa-name": "file name edit"
            }}/>

            <div className="controls">
                <i
                    className="fa fa-check"
                    onClick={() => {
                        valueState.onChange(state.value.value);
                        state.onChange(null);
                    }}
                    xd-qa-type="icon"
                    xd-qa-name="edit check"
                />
                <i
                    className="fa fa-close"
                    onClick={() => state.onChange(null)}
                    xd-qa-type="icon"
                    xd-qa-name="edit close"
                />
            </div>
        </div>
    ),
);
